import { createContext } from 'react';
const SubscreenTrackingContext = /*#__PURE__*/createContext(undefined);
SubscreenTrackingContext.displayName = 'SubscreenTrackingContext';
export default SubscreenTrackingContext;
export const SubscreenTrackingContextProvider = SubscreenTrackingContext.Provider;
export const SubscreenTrackingContextConsumer = SubscreenTrackingContext.Consumer;